
export enum IDeviationMeasure {
    Maintenance,
    ReplaceComponent,
    NewDesign
}
